import useTranslations from 'context/Translations';
import { createListNameFormatter } from 'lib/client/createListNameFormatter/createListNameFormatter';

const useListNameFormatter = () => {
    const translate = useTranslations();
    return createListNameFormatter(translate('DEFAULT_LIST_NAME'));
};

export default useListNameFormatter;
